import React from 'react';
import { useMsal } from '@azure/msal-react';
import { getLoginRequest, getEnvVar } from '../config/authConfig';

const LoginButton = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(getLoginRequest()).catch(e => {
      console.error(e);
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            {getEnvVar('REACT_APP_APP_NAME') || 'Ideal Customer Profile Scoring'}
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Please sign in to access the application
          </p>
        </div>
        
        <div className="mt-8 space-y-6">
          <div>
            <button
              onClick={handleLogin}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <svg className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                </svg>
              </span>
              Sign in with Microsoft
            </button>
          </div>
          
          <div className="text-center">
            <p className="text-xs text-gray-500">
              Secure authentication powered by Microsoft Entra
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginButton;